<template>
  <IQOS
    :systemDependency="mode"
    :enabled="cafe[mode].use_guests_count"
    :title="$t('guests_count_flag.title')"
  >
    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("guests_count_flag.checkbox") }}
    </p>

    <BaseDivider class="mt-16" color="v1-grey-5" v-if="cafe[mode].use_guests_count"/>
    <div class="cutlery-row mt-16" v-if="cafe[mode].use_guests_count">
      <span class="qrw-heading-xs v1-grey-3-color">
        {{ $t("guests_count_flag.paid_title") }}
      </span>
      <BaseToggleSwitcher
        fillBg="background-success-default"
        disabledBg="v1-grey-3"
        fillCircle="v1-grey-3"
        :value="price_active"
        @input="onPriceToggle"
      />
    </div>
    <BaseUnitInput
      class="mt-16 w-100"
      fullWidth
      :unitPlaceholder="currency.symbol"
      :readonly="false"
      :placeholder="$t('guests_count_flag.paid_ph')"
      v-model.number="cutlery_price"
      @blur="onChangePrice(cutlery_price)"
      v-if="price_active && cafe[mode].use_guests_count"
      type="number"
    />
    <p
      class="iqos-comment qrw-paragraph-md mt-16"
      v-if="cafe[mode].use_guests_count"
    >
      {{ $t("guests_count_flag.paid_comment") }}
    </p>

    <template #actions>
      <IQOSToggle :value="cafe[mode].use_guests_count" @input="onChange" />
    </template>
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue";

export default {
  data() {
    return {
      price_active: false,
      cutlery_price: 0,
    };
  },
  components: {
    SlideToggleRow,
  },
  props: {
    mode: {
      type: String,
      default: "delivery",
    },
  },
  methods: {
    onChange(v) {
      if (this.mode == "delivery") {
        this.$store.commit("setDeliveryUseGuestsCount", v);
      } else {
        this.$store.commit("setPreorderUseGuestsCount", v);
      }
      this.$store.dispatch("saveCafe");
    },
    onPriceToggle(v) {
      this.price_active = v;

      if (!this.price_active) {
        this.onChangePrice(0);
      }
    },
    onChangePrice(val) {
      this.$store.commit("setCutleryPrice", {
        mode: this.mode,
        price: val,
      });
      this.$store.dispatch("saveCafe");
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    }
  },
  mounted() {
    this.price_active = this.cafe[this.mode].cutlery_price > 0;
    this.cutlery_price = this.cafe[this.mode].cutlery_price || 0;
  },
};
</script>

<style scoped>
.cutlery-row {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
}

.row-title {
  /* margin-left: 1.65vh; */
  color: #a4a3a1;
  font-size: 2.3vh;
}

.row-title.active {
  color: #ededed;
}
</style>
